export default "__VITE_ASSET__e92a611c__"